import { ProductNameEnum } from './program';

export enum NotificationType {
  MAINTENANCE = 'Maintenance',
  ANNOUNCEMENT = 'Announcement',
}

export enum NotificationStatus {
  ACTIVE = 'Active',
  UPCOMING = 'Upcoming',
  COMPLETED = 'Completed',
}

export const notificationTimeZonesList: string[] = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
];
export interface NotificationDetails {
  startTime: number;
  endTime: number;
  timeZone: string;
  duration: number;
  unitOfTime: number;
}

export interface NewNotification {
  type: NotificationType;
  details: NotificationDetails;
  notify: boolean;
  title: string;
  description: string;
  productName?: ProductNameEnum | 'ALL';
  createdBy?: string;
  createdOn?: Date;
  updatedOn?: Date;
}

export interface Notification extends NewNotification {
  id: string;
}

export interface NotificationWithAcceptance extends Notification {
  isAccepted?: boolean;
}

export interface NotificationAcceptance {
  notificationId: string;
  userId: string;
}

export interface NotificationResponse {
  maintenance: Notification[];
  activeNotifications: Notification[];
  allNotifications: Notification[];
}

export const NotificationStepsInfo = [
  {
    id: 1,
    label: 'Step 1: Notification Details',
    errorMessage: '',
    'data-testid': 'step 1',
  },
  {
    id: 2,
    label: 'Step 2: Publish Settings',
    errorMessage: '',
    'data-testid': 'step 2',
  },
  {
    id: 3,
    label: 'Step 3: Review & Submit',
    errorMessage: '',
    'data-testid': 'step 3',
  },
];

export const defaultMaintenanceMsg = `Please note that we will be experiencing server downtime {0} due to maintenance.`;
export const defaultDateFormatToBeUsed = 'YYYY-MM-DD HH:mm';

export enum UnitOfTimeEnum {
  DAYS = 0,
  HOURS = 1,
}
export const UnitOfTimeValues = [
  {
    label: 'Days',
    value: UnitOfTimeEnum.DAYS,
  },
  {
    label: 'Hours',
    value: UnitOfTimeEnum.HOURS,
  },
];
